import { makeContextModule } from '@cian/react-utils';

import { type FC, type PropsWithChildren } from 'react';

import { useToggleMapButtonHint } from '../hooks/useToggleMapButtonHint';

import { type ToggleMapButtonHintContext } from './types';

export const {
  Context,
  useContext: useToggleMapButtonHintContext,
  withContext: withToggleMapButtonHintContext,
} = makeContextModule<ToggleMapButtonHintContext>({
  contextName: 'ToggleMapButtonHintContext',
});

export const ToggleMapButtonHintContextProvider: FC<PropsWithChildren> = props => {
  const { children } = props;
  const context = useToggleMapButtonHint();

  return <Context.Provider value={context}>{children}</Context.Provider>;
};
